import { UPDATE_ACCOUNT_FEATURES } from 'constants/actionTypes';

export function updateAccountFeatures(features) {
  return {
    type: UPDATE_ACCOUNT_FEATURES,
    payload: features,
  };
}
